module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s136x196-8b02ea6ed8e1ff37508ea892face1d16.png";